module.exports = __webpack_public_path__ + "assets/img/spoken_bg.9d0a517c.png";